import '../enums/GameSpecificTypes.js';
import '../enums/MaxPayoutDataTypes.js';
import '../enums/Chat.js';
import '../enums/GameModes.js';
import '../enums/IconTypes.js';
import '../enums/BetStatus.js';
import '../enums/PopupTypes.js';
import '../enums/ApiVersion.js';
import '../enums/RoundStatus.js';
import '../enums/FreeBetsStatus.js';
import '../enums/SocketEvents.js';
import '../enums/TranslationKeys.js';
import '../enums/TimeoutMaxValue.js';
import '../enums/ApiServiceTypes.js';
import '../enums/EnvironmentTypes.js';
import '../enums/DefaultQueryValues.js';
import '../enums/FreeBetWinningType.js';
import '../enums/DefaultQueryParams.js';
import '../enums/BetHistoryFilterTypes.js';
import '../enums/GameThemeTypes.js';
import '../enums/RequestStatus.js';
import '../enums/FetchDefaultPaths.js';
import '../enums/ResponseCodes.js';
import { w as platformMessageStore, x as freeBetStore } from '../../../loadingStore-df941e1d.js';
import '../store/chatStore.js';
import { wageringStore } from '../store/wageringStore.js';
import '../store/roundInfoStore.js';
import '../store/userCountStore.js';
import '../store/gameResultStore.js';
import '../store/resultHashStore.js';
import '../store/userWinBetsStore.js';
import '../store/notificationStore.js';
import '../store/selectedResultInfoStore.js';
import '../services/liveConnection/types.js';
import 'axios';
import '../services/sound/types.js';
import '../services/sound/SoundService.js';
import '../services/sound/defaultSounds.js';
import '../services/api/types.js';
import '../services/ApiServices.js';
import '../../../momentFormat-14fce7b4.js';
import { BOG_LINE_GAME_TYPES } from '../enums/BogLineGameConfigs.js';
import '../polyfill.js';
import '../../../tslib.es6-14c74580.js';
import 'mobx';
import '@microsoft/signalr';
import '../classes/httpResponse/index.js';
import './environmentBuilder.js';
import '../enums/BogLineGameConfig.js';
import './parseQuery.js';
import '../services/api/BaseApiService.js';
import '../enums/StatisticsSortingTypes.js';
import '../../../table-line/t_types/enums/BetResponseCode.js';
import '../../../table-line/t_types/enums/BetErrorMessages.js';
import '../../../table-line/t_types/enums/NotificationByResponseCode.js';
import '../../../table-line/t_types/enums/FreeChipTypes.js';
import '../../../table-line/t_types/enums/PopupTypes.js';
import './formatDate.js';
import './isMobile.js';
import './updateHalfBets.js';
import '../enums/bogGameNames.js';
import 'howler';
import '../../../_commonjsHelpers-1a7a244d.js';

var freeBetWageringBetButtonState = function (data) {
    var _a;
    var isCrashed = data.isCrashed, isAutoBet = data.isAutoBet, isValidOdd = data.isValidOdd, isDisabled = data.isDisabled, isBetAccepted = data.isBetAccepted, identifyId = data.identifyId, currentOdd = data.currentOdd;
    var partnerWageringOdd = wageringStore.partnerWageringOdd;
    var gameType = platformMessageStore.bogLineGameTypeData.gameType;
    var activeFreeBet = freeBetStore.activeFreeBet, extraFreeBetData = freeBetStore.extraFreeBetData;
    if (gameType !== BOG_LINE_GAME_TYPES.ONLY_MARKET) {
        if (!isBetAccepted && !isDisabled && !isCrashed)
            return 'free-bet active';
        if (isAutoBet && isValidOdd) {
            if (partnerWageringOdd && partnerWageringOdd <= currentOdd && !((_a = extraFreeBetData[identifyId]) === null || _a === void 0 ? void 0 : _a.freeBetId))
                return 'free-bet active';
            if (extraFreeBetData[identifyId].freeBetId && extraFreeBetData[identifyId].freeBetMinOdd <= currentOdd)
                return 'free-bet active';
            if (!extraFreeBetData[identifyId].freeBetId && !partnerWageringOdd)
                return 'free-bet active';
        }
        if (!isAutoBet && isValidOdd) {
            if (partnerWageringOdd && partnerWageringOdd <= identifyId && !extraFreeBetData[identifyId].freeBetId)
                return 'free-bet active';
            if (extraFreeBetData[identifyId].freeBetId &&
                extraFreeBetData[identifyId].freeBetMinOdd <= currentOdd &&
                extraFreeBetData[identifyId].currentIndex === identifyId)
                return 'free-bet active';
            if (!extraFreeBetData[identifyId].freeBetId && !partnerWageringOdd)
                return 'free-bet active';
        }
        return 'free-bet inactive';
    }
    else {
        if ((activeFreeBet.id && activeFreeBet.minOdd > currentOdd) ||
            (partnerWageringOdd && partnerWageringOdd > currentOdd))
            return 'disabled';
    }
};

export { freeBetWageringBetButtonState };
